export default "__VITE_PUBLIC_ASSET__47c2e7aa__"